export const environment = {
    ssr: false,
    brandName: 'Groupbenefitz',
    app: {
        production: true,
        grp: "https://api.groupbenefitz.ca/",
        globalgrp: "https://signup.groupbenefitz.ca/",
        logourl: 'https://api-admin.groupbenefitz.net/api/ap/',
        commonurl: 'https://api-common.groupbenefitz.net/api/cr/',
        waddellink: 'https://signup.groupbenefitz.ca/waddell/',
        langApi: 'https://languageengineapi.groupbenefitz.net/',
        acceptJsUrl: 'https://js.authorize.net/v1/Accept.js',
        iafglink: 'https://signup.groupbenefitz.ca/iafg/',
        kixcare: 'https://signup.groupbenefitz.ca/kixcare/',
        memberPortal: 'https://members.groupbenefitz.net/',
        corporatePortal: 'groupbenefitz.net',
        adminPortal: 'https://api-admin.groupbenefitz.net',
        authorizePortal: 'https://services.igbms.com/',
        authorizeNet: true, // make it to true after setup for new apis subscription and registration have handled
        clientKey: '34LwFKk53macuZ5AHk3HFr24rM38ZkvcwxPV558R5s9ZhLm68rVdLxXhre3U2Jua',
        apiLoginID: '3J47gF32ve',
        localgrp: 'https://localhost:4001/',
        atp: 'https://dev.aitestpro.com/',

        id: 'fooClientId',
        key: 'secret',
    },

  googleMapKey: 'AIzaSyCx_ZaqWDu6leZ7ffeIz5sG9qrN5s4KFF0',
  debugEnabled: true,
};
